import axios from 'axios';
import config from '../../../config';

const baseUrl = config.baseUrl;
const baseEndpoint = `${baseUrl}/api/formato-sostenibilidad`;


//Sostenibilidad
export const getAllProyectosFormatos = async () => {
    const response = await axios.get(`${baseEndpoint}/proyectos`);
    return response.data;
};


export const getAllProyectoByid = async (id, id_tipo_formato) => {
    const response = await axios.get(`${baseEndpoint}/proyectos/${id}/${id_tipo_formato}`);
    return response.data;
};


export const postProyectoFormato = async (id_proyecto,data) => {
    const response = await axios.post(`${baseEndpoint}/proyecto/${id_proyecto}`, data);
    return response.data;
};

// Subir o reemplazar acta de un participante
export async function subirFormatoSostenibilidad(oid_proyecto, proyecto, oidTipoFormato, cargado_por, archivo) {
    const formData = new FormData();
    formData.append('proyecto', proyecto);
    formData.append('oidTipoFormato', oidTipoFormato);
    if (cargado_por) formData.append('cargado_por', cargado_por);
    formData.append('archivo', archivo);

    const response = await axios.post(
        `${baseEndpoint}/subir/${oid_proyecto}`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return response.data;
}



// Descarga individual  sin autenticacion
/*
export async function getDescargarFormato(oid_proyecto, oid_tipo_formato) {

    const response = await axios.get(
        `${baseEndpoint}/download-formato/${oid_proyecto}/${oid_tipo_formato}`,
        { responseType: 'blob' }
    );

    // 🔥 Obtener nombre desde headers
    const contentDisposition = response.headers['content-disposition'];

    let nombreArchivo = 'documento.pdf';

    if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+)"?/);
        if (match && match[1]) {
            nombreArchivo = match[1];
        }
    }

    // Crear blob
    const blob = new Blob([response.data], { type: response.headers['content-type'] });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.setAttribute('download', nombreArchivo);

    document.body.appendChild(link);
    link.click();

    link.remove();
    window.URL.revokeObjectURL(url);
}
*/


export async function getDescargarFormato(oid_proyecto, oid_tipo_formato) {
    window.open(
        `${baseEndpoint}/download-formato/${oid_proyecto}/${oid_tipo_formato}`,
        "_blank"
    );
}